import { defineReactComponent } from "../shared/react/angular";
import { CancelButton, CloseButton, DefaultButton, DialogFooter, DialogFooterButtons, SaveButton } from "../shared/react/DialogFooter";
import { DialogHeader } from "../shared/react/DialogHeader";
import { FormGroupNumericInput, NumericInput } from "../shared/react/NumericInput";
import { classes, convertStyle } from "../shared/react/react";
import { FormGroupSelect, FormGroupSelectNumber, Select, SelectNumber } from "../shared/react/Select";
import { FormGroupTextArea, FormGroupTextInput, TextArea, TextInput } from "../shared/react/TextInput";
import { DialogBody } from "../shared/react/DialogBody";
import { Dialog } from "../shared/shell/dialog";
import { Checkbox } from "../shared/react/checkbox";
import { InfoPopoverButton } from "../shared/react/buttons/InfoPopoverButton";
import { ExpandButton } from "../shared/react/buttons/ExpandButton";
import { CollapseButton } from "../shared/react/buttons/CollapseButton";
import { ColorPickerButton } from "../shared/react/ColorPicker";
import { CropCircles } from "../shared/react/CropCircle";
import { YearsPicker } from "../shared/components/years/YearsPicker";
import { Msg, MsgFormat } from "../shared/react/Msg";
import { Popup } from "../shared/react/Popup";
import { CropLabel } from "../shared/react/CropLabel";
import { FormGroup } from "../shared/react/FormGroup";
import { DatePicker, DateStringPicker } from "../shared/react/datePicker/DatePicker";
import { MapView } from "../shared/react/MapView";
import { Slider } from "../shared/react/Slider";
import { useActiveElement, useAsyncValue, useDebouncedValue, useDebouncedValueWithSetter, useDisableShell, useDispose, useOutsideClick, useSizeObserver } from "../shared/react/hooks";
import { showDeleteCancel, showInfo, showMessageBox, showOkCancel, showWarning, showYesNo } from "../shared/react/msgbox";
import { showDialog } from "../shared/react/dialog";
import { DropDownMenu } from "../shared/react/dropdown";
import { Typeahead2 } from "../shared/react/Typeahead2/Typeahead2";
import { Card, CardSmall } from "../shared/react/Card";
import { createErrorHandler } from "../shared/react/error";
import { createReactOmniaModule } from "../shared/react/module";
import { MultiSelect } from "../shared/react/MultiSelect";
import { ViewSelect } from "../shared/react/viewSelect";
import { ApiInterface } from "../shared/react/api";
import { ErrorBoundary } from "../shared/react/errorBoundary";
import { setupChart } from "../shared/react/chart";
import { Typeahead } from "../shared/react/Typeahead";
import { RadioButton } from "../shared/react/RadioButton";
import { RadioButtonGroup } from "../shared/react/RadioButtonGroup";
import { FileSelector } from "../shared/react/FileSelector";
import { AnalysisValueGauge } from "../shared/react/Gauge";
import { memoizeReactConfig } from "../shared/react/reactDirective";
import { TermsAndConditionsDialog } from "@omnia/shared/react/TermsAndConditionsDialog";
import { Button } from "../shared/react/buttons/Button";

export const react = {

    classes,
    clsx: classes,
    createErrorHandler,
    createReactOmniaModule,
    defineReactComponent,
    convertStyle,
    ApiInterface,
    FormGroup,
    FormGroupTextInput,
    FormGroupSelect,
    FormGroupNumericInput,
    FormGroupSelectNumber,
    SelectNumber,
    TextInput,
    Checkbox,
    CollapseButton,
    ExpandButton,
    InfoPopoverButton,
    NumericInput,
    DialogFooter,
    DialogHeader,
    DialogBody,
    DialogFooterButtons,
    Dialog,
    DatePicker,
    DateStringPicker,
    Card,
    CardSmall,
    MapView,
    ColorPickerButton,
    CropCircles,
    YearsPicker,
    Msg,
    MsgFormat,
    Popup,
    SaveButton,
    CloseButton,
    DefaultButton,
    CancelButton,
    CropLabel,
    Slider,
    ViewSelect,
    ErrorBoundary,
    useSizeObserver,
    useDebouncedValueWithSetter,
    showOkCancel,
    showDialog,
    showDeleteCancel,
    showMessageBox,
    showInfo,
    showWarning,
    showYesNo,
    DropDownMenu,
    Typeahead,
    Typeahead2,
    MultiSelect,
    RadioButton,
    TextArea,
    Select,
    FormGroupTextArea,
    RadioButtonGroup,
    FileSelector,
    AnalysisValueGauge,
    TermsAndConditionsDialog,
    Button,
    useDisableShell,
    useAsyncValue,
    useDispose,
    useOutsideClick,
    useActiveElement,
    useDebouncedValue,
    memoizeReactConfig,

    chart: {
        setupChart
    }

}